import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4D0NouXISP3NeltpheeRp0KIEX-pvW-A",
  authDomain: "jewellery-92594.firebaseapp.com",
  projectId: "jewellery-92594",
  storageBucket: "jewellery-92594.firebasestorage.app",
  messagingSenderId: "401991431524",
  appId: "1:401991431524:web:15ca3bfc4749c296adf671",
  measurementId: "G-40KBQX4HN9"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export default app;